import React from "react";
import { useToast } from "../../context/ToastContext";
import { assignmentLabel, formatDate, formatTime12Hr, isOverdue } from "../../utils/format";
import { openWhatsApp, reminderText } from "../../utils/whatsapp";

/* One compact schedule row (dashboard widget and calendar sidebar); clicking it opens that day. */
export default function ScheduleListItem({ item, className, onOpen }) {
  const showToast = useToast();
  const open = () => onOpen(item.date);
  const assignment = assignmentLabel(item);

  return (
    <div
      className={className}
      title="Click to view date schedule"
      role="button"
      tabIndex={0}
      onClick={open}
      onKeyDown={(e) => e.target === e.currentTarget && (e.key === "Enter" || e.key === " ") && open()}
    >
      <div className="simple-item-left">
        <span className={`simple-dot simple-dot-${item.type}`}></span>
        <div className="simple-item-text">
          <div className="simple-item-title">{item.title || "Scheduled Item"}</div>
          <div className="simple-item-time">
            <span className="icon-bright-cal">📅</span> {formatDate(item.date)} •{" "}
            <span className="icon-bright-clock">⏰</span> {formatTime12Hr(item.time) || "All day"}
            {isOverdue(item) && <span className="simple-item-tag tag-overdue">Overdue</span>}
          </div>
          {assignment && <div className="simple-item-assignee">👤 {assignment}</div>}
        </div>
      </div>
      <button
        type="button"
        className="btn-simple-wa"
        title="Send WhatsApp Alert"
        onClick={(e) => {
          e.stopPropagation();
          openWhatsApp(reminderText(item));
          showToast("Opening WhatsApp with reminder alert...", "info");
        }}
      >
        💬
      </button>
    </div>
  );
}
